import React from "react";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

import { StrictMode } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";

import App from "./App";
import { AuthProvider, UserProvider, VideoProvider } from "./contexts";

const rootElement = document.getElementById("root");
ReactDOM.render(
  <StrictMode>
    <Router>
      <AuthProvider>
        <UserProvider>
          <VideoProvider>
            <App />
          </VideoProvider>
        </UserProvider>
      </AuthProvider>
    </Router>
  </StrictMode>,
  rootElement
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
